import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()

export class SubscriptionsService {
    public currencyCountryCode = new Subject<boolean>();
    public gpmTime = new Subject<number>();
    private subject = new Subject<any>();
    private reloadCartNow = new Subject<boolean>();
    private login = new Subject<any>();
    private gameClicked = new Subject<boolean>();
    private oldBanner = new Subject<any>();
    private login_tmp = new Subject<any>();
    private register = new Subject<any>();
    private registerOrLogin = new Subject<any>();
    private onlyPmStepV = new Subject<any>();
    private pay = new Subject<any>();
    private gpm = new Subject<any>();
    private cart = new Subject<any>();
    private changePassword = new Subject<any>();
    private addFunds = new Subject<any>();
    private goToAPM = new Subject<any>();
    private winnerConfetti = new Subject<any>();
    private jinniTooltip = new Subject<any>();
    private jinniError = new Subject<any>();
    private isCart = new Subject<any>();
    private cartLogin = new Subject<any>();
    private paymentMethod = new Subject<any>();
    private cartItemsUpdate = new Subject<any>();
    public userBalance = new Subject<any>();
    public freshRegistredInCasino = new Subject<any>();
    public userDataNameWithGender = new Subject<any>();
    public userBalanceOnWithdraw = new Subject<any>();
    public language = new Subject<any>();
    public paymentModal = new Subject<any>();
    public virtualLogin = new Subject<any>();
    public userData = new Subject<any>();
    public showLogin = new Subject<any>();
    public showLogin_tmp = new Subject<any>();
    public closeMiniCheckout = new Subject<any>();
    public modalState = new Subject<any>();
    public scratchBannerData = new Subject<any>();
    public scratchCategory = new Subject<any>();
    public isLogin = new Subject<any>();
    public closeGame = new Subject<any>();
    public refreshEntries = new Subject<any>();
    public closeModal = new Subject<any>();
    public casinoWelcome = new Subject<any>();
    public updateMyScratch = new Subject<any>();
    public playGameFromEntries = new Subject<any>();
    public runScratchcardCheckout = new Subject<any>();
    public handleScratchCareousel = new Subject<any>();
    public loadingButton = new Subject<any>();
    public scratch = new Subject<any>();
    public content = new Subject<any>();
    public closeDMsmooth = new Subject<boolean>();
    public holdModalOberlay = new Subject<boolean>();
    public startInstant = new Subject<any>();
    public hideInstantBanner = new Subject<any>();
    public gameCategory = new Subject<any>();
    public gameDisable = new Subject<any>();
    public userNeedIncreseBalance = new Subject<any>();
    public logOut = new Subject<any>();
    public dashState = new Subject<any>();
    public resetToken = new Subject<any>();
    public resetEmail = new Subject<any>();
    public resetPassword = new Subject<any>();
    public showForgetPassword = new Subject<any>();
    public modalSize = new Subject<any>();
    public addFundsModalState = new Subject<any>();
    public showAddFundsModal = new Subject<boolean>();
    public runGame = new Subject<any>();
    public updateOrderId = new Subject<any>();
    public forceStepTwo = new Subject<any>();
    public error74 = new Subject<boolean>();
    public errorDefault = new Subject<boolean>();
    public userAfterRegister = new Subject<any>();
    public countryCode = new Subject<any>();
    public triggerAffiliate = new Subject<any>();
    public vision = new Subject<any>();
    public showAll = new Subject<any>();
    public countryCodeValue: any;
    public loginBanned = new Subject<boolean>();
    public registerBanned = new Subject<boolean>();
    private showSuccessPayment = new Subject<any>();
    public casinoCategory = new Subject<any>();
    private incomingDraws = new Subject<any>();
    public fireRegisterPixel = new Subject<any>();
    public isAddFundsOpen = new Subject<any>();
    public fakeCart = new Subject<boolean>();
    public currentGameId = new Subject<string>();
    public newUser = new Subject<boolean>();
    public ifInCart = new Subject<boolean>();
    public ifGameRun = new Subject<boolean>();
    public currency = new Subject<any>();
    public sendPayment = new Subject<string>();
    public ifGameClose = new Subject<boolean>();
    public depositTrigger = new Subject<boolean>();
    public gameBackground = new Subject<string>();
    public restrictedLoginRegister = new Subject<boolean>();
    public miniCheckoutAddPM = new Subject<boolean>();
    public moreMoney = new Subject<boolean>();
    public addPmOpen = new Subject<boolean>();
    public modalClosing = new Subject<boolean>();
    public addToCartScratch = new Subject<boolean>();
    public nameMagic = new Subject<boolean>();
    public finishedLoadingOnScratchHomepage = new Subject<boolean>();
    public triggeredEndGameSessionIG = new Subject<boolean>();
    public openUniversalJinniErrorModal = new Subject<boolean>();
    public universalJinniErrorModalData = new Subject<any>();
    public reloadGame = new Subject<any>();
    forceOpen: boolean;
    holdCasinoModalVisible: boolean;
    miniCheckoutEnabled: boolean;
    public freshLogin = new Subject<boolean>();
    updateRunScratchcardCheckoutObject: object;
    isFreshRegisteredForFDB: boolean;
    public isCookieSet = new Subject<boolean>();

    constructor() {
        this.forceOpen = false;
        this.holdCasinoModalVisible = false;
        this.miniCheckoutEnabled = false;
    }
    getIsCookieSet(): Observable<any> {
      return this.isCookieSet.asObservable();
    }

    setIsCookieSet(data) {
      this.isCookieSet.next(data);
    }
    updateUniversalJinniErrorModalData(data: any) {
        this.universalJinniErrorModalData.next(data);
    }

    getUniversalJinniErrorModalData(): Observable<any> {
        return this.universalJinniErrorModalData.asObservable();
    }

    updateOpenUniversalJinniErrorModal(data: any) {
        this.openUniversalJinniErrorModal.next(data);
    }

    getOpenUniversalJinniErrorModal(): Observable<any> {
        return this.openUniversalJinniErrorModal.asObservable();
    }

    updateTriggeredEndGameSessionIG(data: any) {
        this.triggeredEndGameSessionIG.next(data);
    }

    getTriggeredEndGameSessionIG(): Observable<any> {
        return this.triggeredEndGameSessionIG.asObservable();
    }

    getFreshLogin(): Observable<boolean> {
        return this.freshLogin.asObservable();
    }

    emitFreshLogin(freshLogin: boolean) {
        this.freshLogin.next(freshLogin);
    }

    updateFinishedLoadingOnScratchHomepage(data: any) {
        this.finishedLoadingOnScratchHomepage.next(data);
    }

    getFinishedLoadingOnScratchHomepage(): Observable<any> {
        return this.finishedLoadingOnScratchHomepage.asObservable();
    }


    triggerAddToCartScratch(data: any) {
        this.addToCartScratch.next(data);
    }

    getAddToCartScratch(): Observable<any> {
        return this.addToCartScratch.asObservable();
    }

    setIsRestrictedLoginRegister(data: boolean) {
        this.restrictedLoginRegister.next(
            data
        );
    }

    getIsRestrictedLoginRegister(): Observable<any> {
        return this.restrictedLoginRegister.asObservable();
    }

    setIsLoginBanned(data: boolean) {
        this.loginBanned.next(
            data
        );
    }

    getIsLoginBanned(): Observable<any> {
        return this.loginBanned.asObservable();
    }

    setIsRegisterBanned(data: boolean) {
        this.registerBanned.next(
            data
        );
    }

    getIsRegisterBanned(): Observable<any> {
        return this.registerBanned.asObservable();
    }

    updateMiniCheckoutAddPM(miniCheckoutAddPM) {
        this.miniCheckoutAddPM.next(
            miniCheckoutAddPM
        );
    }

    emitMiniCheckoutAddPM(miniCheckoutAddPM) {
        this.miniCheckoutAddPM.next(
            miniCheckoutAddPM
        );
    }

    getMiniCheckoutAddPM(): Observable<any> {
        return this.miniCheckoutAddPM.asObservable();
    }

    updateCurrencyCountryCode(country) {
        this.currencyCountryCode = country;
    }

    emitCurrencyCountryCode(country) {
        this.currencyCountryCode.next(
            country
        );
    }

    updateGPMserviceTimestamp(time: number) {
        this.gpmTime.next(
            time
        );
    }

    getGPMserviceTimestamp(): Observable<any> {
        return this.gpmTime.asObservable();
    }

    triggerDepositService(deposit: any) {
        this.depositTrigger.next(
            deposit
        );
    }

    getDeposit(): Observable<any> {
        return this.depositTrigger.asObservable();
    }

    triggerNameMagic(nameMagic: any) {
        this.nameMagic.next(
            nameMagic
        );
    }

    getNameMagic(): Observable<any> {
        return this.nameMagic.asObservable();
    }

    updateCart(cartLength: number) {
        this.subject.next(
            cartLength
        );
    }

    reloadCart(reloadNow: boolean) {
        this.reloadCartNow.next(reloadNow);
    }

    emitCasinoCategory(cat: any) {
        this.casinoCategory.next(
            cat
        );
    }

    emitGameBackground(url: string) {
        this.gameBackground.next(
            url
        );
    }

    emitFireRegisterPixel(pixel: any) {
        this.fireRegisterPixel.next(
            pixel
        );
    }

    emitShowSuccessPayment(state: boolean) {
        this.showSuccessPayment.next(
            state
        );
    }

    updateCountryCode(country) {
        this.countryCodeValue = country;
    }

    getCountryCode(): Observable<any> {
        return this.countryCodeValue.asObservable();
    }

    getRunGame(gameId: string) {
        this.runGame.next(
            gameId
        );
    }

    updateCartItems(cart: any) {
        this.cartItemsUpdate.next(
            cart
        );
    }

    updateOrderIdNow(orderId: number) {
        this.updateOrderId.next(orderId);
    }

    updatePlayGameFromEntries(game: any) {
        this.playGameFromEntries.next(
            game
        );
    }

    updateRunScratchcardCheckout(scratch: any) {
        this.runScratchcardCheckout.next(
            scratch
        );
    }

    upodateHandleScratchCarousel(carousel: any) {
        this.handleScratchCareousel.next(
            carousel
        );
    }

    emitCloseGame(game: boolean) {
        this.closeGame.next(game);
    }

    emitStartInstant(instant: string) {
        this.startInstant.next(instant);
    }

    emitHideInstantBanner(instant: boolean) {
        this.hideInstantBanner.next(instant);
    }

    emitRefreshEntries(refEntr: any) {
        this.refreshEntries.next(refEntr);
    }


    emitCloseAddFundsModal(data: any) {
        this.addFundsModalState.next(
            data
        );
    }

    checkIfLoadingButton(data: any) {
        this.loadingButton.next(
            data
        );
    }

    triggerReloadGame(data: any) {
        this.reloadGame.next(
            data
        );
    }


    updateMyScratchSection(scratch: boolean) {
        this.updateMyScratch.next(
            scratch
        );
    }

    updateBalance(balance: any) {
        this.userBalance.next(balance);
    }

    emitFreshRegisteredInCasino(fric: boolean) {
        this.freshRegistredInCasino.next(fric);
    }

    updateUserDataNameWithGender(data: any) {
        this.userDataNameWithGender.next(data);
    }

    updateBalanceOnWithdraw(balance: any) {
        this.userBalanceOnWithdraw.next(balance);
    }

    updatePaymentMethod(payment: boolean) {
        this.paymentMethod.next({
            payment: payment
        });
    }

    closeModalNow(modal: boolean) {
        this.closeModal.next(modal);
    }

    openCasinoWelcomeNow(casWel: boolean) {
        this.casinoWelcome.next(casWel);
    }

    updateBannerFromAllScratch(data: any) {
        this.scratchBannerData.next(data);
    }

    updateCategoryFromAllScratch(data: any) {
        this.scratchCategory.next(data);
    }

    updateLogout(logout: boolean) {
        this.logOut.next(
            logout
        );
    }

    updateVision(vision: any) {
        this.vision.next(vision);
    }

    updateShowAll(vision: any) {
        this.showAll.next(vision);
    }

    updateIncomingDraws(incomingDraws: boolean) {
        this.incomingDraws.next(
            incomingDraws
        );
    }


    emitLanguage(lang: string) {
        this.language.next(
            lang
        );
    }

    emitGameCategory(category: any[]) {
        this.gameCategory.next(
            category
        );
    }

    emitGameDisable(category: any[]) {
        this.gameDisable.next(
            category
        );
    }

    emitUserNeedMoreMoney(gameID: any) {
        this.moreMoney.next(
            gameID
        );
    }

    holdAddPmOpen(addPmOpen: boolean) {
        this.addPmOpen.next(addPmOpen);
    }

    emitUserNeedIncreseBalance(incBal: any) {
        this.userNeedIncreseBalance.next(
            incBal
        );
    }

    emitShowAddFundsModal(esafm: boolean) {
        this.showAddFundsModal.next(
            esafm
        );
    }

    emitPaymentModal(paymentModal: boolean) {
        this.paymentModal.next(
            paymentModal
        );
    }

    emitToggleContent(flag: boolean) {
        this.content.next(
            flag
        );
    }

    emitCloseDepositModalSmoothly(closeIt: boolean) {
        this.closeDMsmooth.next(
            closeIt
        );
    }

    emitHoldModalOberlay(closeIt: boolean) {
        this.holdModalOberlay.next(
            closeIt
        );
    }

    emitVirtualLogin(virtualLogin: string) {
        this.virtualLogin.next(
            virtualLogin
        );
    }

    emitShowLogin(showLogin: boolean) {
        this.showLogin.next(
            showLogin
        );
    }

    emitShowLogin_tmp(showLogin_tmp: boolean) {
        this.showLogin_tmp.next(
            showLogin_tmp
        );
    }

    emitUserData(userData: boolean) {
        this.userData.next(
            userData
        );
    }

    emitDashboardState(value: number) {
        this.dashState.next(
            value
        );
    }

    emitResetToken(value: string) {
        this.resetToken.next(
            value
        );
    }

    emitResetEmail(value: string) {
        this.resetEmail.next(
            value
        );
    }

    emitResetPassword(value: any) {
        this.resetPassword.next(
            value
        );
    }

    emitShowForgetPassword(value: any) {
        this.showForgetPassword.next(
            value
        );
    }

    emitModalSize(value: any) {
        this.modalSize.next(
            value
        );
    }

    emitLogin(login: boolean) {
        this.login
            .next(
                login
            );
    }

    emitGameClicked(gameClicked: boolean) {
        this.gameClicked
            .next(
                gameClicked
            );
    }

    emitFakeCart(fc: boolean) {
        this.fakeCart.next(fc);
    }

    emitCurrentGameId(gameID: string) {
        this.currentGameId.next(gameID);
    }

    emitNewUser(nu: boolean) {
        this.newUser.next(nu);
    }


    emitShowOldBanner(oldBanner: boolean) {
        this.oldBanner
            .next(
                oldBanner
            );
    }

    emitLogin_tmp(login_tmp: boolean) {
        this.login_tmp
            .next(
                login_tmp
            );
    }

    emitIsLoggedIn(login: boolean) {
        this.isLogin
            .next(
                login
            );
    }

    emitNewScratch(scratch: any) {
        this.scratch.next(scratch);
    }

    emitIsCart(isCart: boolean) {
        this.isCart.next(isCart);
    }

    emitModalState(modal: boolean) {
        this.modalState.next(modal);
    }

    emitRegister(register: boolean) {
        this.register.next(
            register
        );
    }

    emitRegisterOrLogin(register: boolean) {
        this.registerOrLogin.next(
            register
        );
    }

    onlyPmStep(onlyPmStep: boolean) {
        this.onlyPmStepV.next(
            onlyPmStep
        );
    }

    emitPay(pay: boolean) {
        this.pay.next(
            pay
        );
    }

    emitGetPaymentMethods(gpm: any) {
        this.gpm.next(
            gpm
        );
    }

    emitForceStepTwo(forceStepTwo: boolean) {
        this.forceStepTwo.next(
            forceStepTwo
        );
    }

    emitChangePassword(changePassword: boolean) {
        this.changePassword.next(
            changePassword
        );
    }

    emitCart(cart: any) {
        this.cart.next(
            cart
        );
    }

    emitAddFunds(addFunds: boolean) {
        this.addFunds.next(
            addFunds
        );
    }

    emitGoToAPM(goToAPM: boolean) {
        this.goToAPM.next(
            goToAPM
        );
    }

    emitWinnerConfetti(data: boolean) {
        this.winnerConfetti.next(
            data
        );
    }

    emitJinniTooltip(data: any) {
        this.jinniTooltip.next(
            data
        );
    }

    emitJinniError(data: string | number) {
        this.jinniError.next(
            data
        );
    }

    emitCloseMiniCheckout(closeMiniCheckout: boolean) {
        this.closeMiniCheckout.next(
            closeMiniCheckout
        );
    }

    emitUserAfterRegistration(data: any) {
        this.userAfterRegister.next(
            data
        );
    }

    emitFirstTimeAffiliate(data: boolean) {
        this.triggerAffiliate.next(
            data
        );
    }

    setIsAddFundsOpen(flag: boolean) {
        this.isAddFundsOpen.next(
            flag
        );
    }

    checkIfInCart(data: boolean) {
        this.ifInCart.next(
            data
        );
    }

    checkIfGameRun(data: boolean) {
        this.ifGameRun.next(
            data
        );
    }

    emitChangeCurrency(currency: any) {
        this.currency.next(
            currency
        );
    }

    emitSendPayment(sendPayment: string) {
        this.sendPayment.next(sendPayment);
    }

    checkIfGameClose(data: boolean) {
        this.ifGameClose.next(
            data
        );
    }

    emitModalClosing(data: boolean) {
        this.modalClosing.next(
            data
        );
    }

    getIfModalClosing(): Observable<any> {
        return this.modalClosing.asObservable();
    }

    getIfGameClose(): Observable<any> {
        return this.ifGameClose.asObservable();
    }

    getIfGameRun(): Observable<any> {
        return this.ifGameRun.asObservable();
    }

    getChangeCurrency(): Observable<string> {
        return this.currency.asObservable();
    }

    getSendPayment(): Observable<string> {
        return this.sendPayment.asObservable();
    }

    getIfInCart(): Observable<any> {
        return this.ifInCart.asObservable();
    }

    getIsAddFundsOpen(): Observable<any> {
        return this.isAddFundsOpen.asObservable();
    }

    getFirstTimeAffiliate(): Observable<any> {
        return this.triggerAffiliate.asObservable();
    }

    getCCode(): Observable<any> {
        return this.countryCode.asObservable();
    }

    getLogin(): Observable<any> {
        return this.login.asObservable();
    }

    getFakeCart(): Observable<boolean> {
        return this.fakeCart.asObservable();
    }

    getCurrentGameId(): Observable<string> {
        return this.currentGameId.asObservable();
    }

    getNewUser(): Observable<boolean> {
        return this.newUser.asObservable();
    }

    getGameClicked(): Observable<boolean> {
        return this.gameClicked.asObservable();
    }

    getReloadCart(): Observable<boolean> {
        return this.reloadCartNow.asObservable();
    }

    getOldBanner(): Observable<any> {
        return this.oldBanner.asObservable();
    }

    getRegister(): Observable<any> {
        return this.register.asObservable();
    }

    getRegisterOrLogin(): Observable<any> {
        return this.registerOrLogin.asObservable();
    }

    getOnlyPmStep(): Observable<any> {
        return this.onlyPmStepV.asObservable();
    }

    getPay(): Observable<any> {
        return this.pay.asObservable();
    }

    getPaymentMethods(): Observable<any> {
        return this.gpm.asObservable();
    }

    getChangePassword(): Observable<any> {
        return this.changePassword.asObservable();
    }

    getRegistrationFirstTime(): Observable<any> {
        return this.fireRegisterPixel.asObservable();
    }

    getCart(): Observable<any> {
        return this.cart.asObservable();
    }

    getAddFunds(): Observable<any> {
        return this.addFunds.asObservable();
    }

    getGoToAPM(): Observable<any> {
        return this.goToAPM.asObservable();
    }

    getWinnerConfetti(): Observable<any> {
        return this.winnerConfetti.asObservable();
    }

    getJinniTooltip(): Observable<any> {
        return this.jinniTooltip.asObservable();
    }

    getJinniError(): Observable<any> {
        return this.jinniError.asObservable();
    }

    getLanguage(): Observable<any> {
        return this.language.asObservable();
    }

    getIsCart(): Observable<any> {
        return this.isCart.asObservable();
    }

    getBannerFromAllScratch(): Observable<any> {
        return this.scratchBannerData.asObservable();
    }

    getScratchCategory(): Observable<any> {
        return this.scratchCategory.asObservable();
    }

    getModalState(): Observable<any> {
        return this.modalState.asObservable();
    }

    getCartItems(): Observable<any> {
        return this.subject.asObservable();
    }

    getLoadingButton(): Observable<any> {
        return this.loadingButton.asObservable();
    }

    getCartItemsUpdate(): Observable<any> {
        return this.cartItemsUpdate.asObservable();
    }

    getUpdateMethod(): Observable<any> {
        return this.paymentMethod.asObservable();
    }

    getCartLogin(): Observable<any> {
        return this.cartLogin.asObservable();
    }

    getCloseModal(): Observable<any> {
        return this.closeModal.asObservable();
    }

    getCasinoWelcome(): Observable<any> {
        return this.casinoWelcome.asObservable();
    }

    getScratchUpdate(): Observable<any> {
        return this.updateMyScratch.asObservable();
    }

    getScratch(): Observable<any> {
        return this.scratch.asObservable();
    }

    getDashState(): Observable<any> {
        return this.dashState.asObservable();
    }

    getResetToken(): Observable<any> {
        return this.resetToken.asObservable();
    }

    getResetEmail(): Observable<any> {
        return this.resetEmail.asObservable();
    }

    getResetPassword(): Observable<any> {
        return this.resetPassword.asObservable();
    }

    getShowForgetPassword(): Observable<any> {
        return this.showForgetPassword.asObservable();
    }

    getModalSize(): Observable<any> {
        return this.modalSize.asObservable();
    }


    getBalance(): Observable<any> {
        return this.userBalance.asObservable();
    }

    getFreshRegisteredInCasino(): Observable<boolean> {
        return this.freshRegistredInCasino.asObservable();
    }

    getToggleContent(): Observable<any> {
        return this.content.asObservable();
    }

    getCloseDepositModalSmoothly(): Observable<boolean> {
        return this.closeDMsmooth.asObservable();
    }

    getHoldModalOverlay(): Observable<boolean> {
        return this.holdModalOberlay.asObservable();
    }

    getCloseGameStatus(): Observable<any> {
        return this.closeGame.asObservable();
    }

    getStartInstant(): Observable<any> {
        return this.startInstant.asObservable();
    }

    getReloadGame(): Observable<any> {
        return this.reloadGame.asObservable();
    }

    getHideInstantBanner(): Observable<any> {
        return this.hideInstantBanner.asObservable();
    }

    getUserDataNameWithGender(): Observable<any> {
        return this.userDataNameWithGender.asObservable();
    }

    getWithdrawBalance(): Observable<any> {
        return this.userBalanceOnWithdraw.asObservable();
    }

    getPaymentModalStatus(): Observable<any> {
        return this.paymentModal.asObservable();
    }

    getVirtualLogin(): Observable<any> {
        return this.virtualLogin.asObservable();
    }

    getShowLogin(): Observable<any> {
        return this.showLogin.asObservable();
    }

    getShowLogin_tmp(): Observable<any> {
        return this.showLogin_tmp.asObservable();
    }

    getUserData(): Observable<any> {
        return this.userData.asObservable();
    }

    getCloseMiniCheckout(): Observable<any> {
        return this.closeMiniCheckout.asObservable();
    }

    getShowSuccessPaymentMethodStatus(): Observable<any> {
        return this.showSuccessPayment.asObservable();
    }

    getLoggedInStatus(): Observable<any> {
        return this.isLogin.asObservable();
    }

    getGameFromMyEntries(): Observable<any> {
        return this.playGameFromEntries.asObservable();
    }

    getScratchcardCheckout(): Observable<any> {
        return this.runScratchcardCheckout.asObservable();
    }

    getHandleScratchCareousel(): Observable<any> {
        return this.handleScratchCareousel.asObservable();
    }

    getGameCategory(): Observable<any> {
        return this.gameCategory.asObservable();
    }

    getGameDisable(): Observable<any> {
        return this.gameDisable.asObservable();
    }

    getUserNeedIncraseBalance(): Observable<any> {
        return this.userNeedIncreseBalance.asObservable();
    }

    getShowAddFundsModal(): Observable<boolean> {
        return this.showAddFundsModal.asObservable();
    }

    getRefreshEntries(): Observable<any> {
        return this.refreshEntries.asObservable();
    }

    getLogout(): Observable<any> {
        return this.logOut.asObservable();
    }

    getAddFundsModalState(): Observable<any> {
        return this.addFundsModalState.asObservable();
    }

    getRunGameFromAddFunds(): Observable<any> {
        return this.runGame.asObservable();
    }

    getForceStepTwo(): Observable<any> {
        return this.forceStepTwo.asObservable();
    }

    getUserAfterRegistration(): Observable<any> {
        return this.userAfterRegister.asObservable();
    }

    getVision(): Observable<any> {
        return this.vision.asObservable();
    }

    getShowAll(): Observable<any> {
        return this.showAll.asObservable();
    }

    getCasinoCategory(): Observable<any> {
        return this.casinoCategory.asObservable();
    }

    getGameBackground(): Observable<string> {
        return this.gameBackground.asObservable();
    }

    getIncomingDraws(): Observable<any> {
        return this.incomingDraws.asObservable();
    }

    getUserNeedMoreMoney(): Observable<any> {
        return this.moreMoney.asObservable();
    }

    getAddPmOpen(): Observable<boolean> {
        return this.addPmOpen.asObservable();
    }


    /* errors part, separated, because we need to refector that */
    emitError74(error74: boolean) {
        this.error74.next(
            error74
        );
    }


    getError74(): Observable<any> {
        return this.error74.asObservable();
    }

    emitErrorDefault(errorDefault: boolean) {
        this.errorDefault.next(
            errorDefault
        );
    }


    getErrorDefault(): Observable<any> {
        return this.errorDefault.asObservable();
    }

}
